var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"res-confirm"},[_c('div',{staticClass:"confirm"},[_c('confirm-card')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }